import React, { useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInterceptor';
import { toast } from 'react-toastify';
import { ImageLink } from '../constants';
import CommonEditor from './CommonEditor';

const AddContent = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const formRef = useRef(null);
    const editData = location.state;

    const [data, setData] = useState({
        position: editData?.position || '',
        title: editData?.title || '',
        description: editData?.description || '',
        desktopImg: editData?.desktopImg || [],
        isActive: editData?.isActive || false,
    });
    const [errors, setErrors] = useState({
        position: '',
        title: '',
    });

    const handleChange = (e) => {
        const { name, files, checked, value } = e.target;
        if (name === 'desktopImg') {
            setData({ ...data, desktopImg: Array.from(files) });
        } else if (name === "isActive" || name === "showInHome") {
            setData({ ...data, [name]: checked });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        if (!data.position.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                position: 'Position is required'
            }));
            hasErrors = true;
        }

        if (!data.title) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                title: 'Title is required'
            }));
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("position", data.position);
            formData.append("title", data.title);
            formData.append("description", data.description);
            data.desktopImg.forEach((img) => {
                formData.append(`desktopImg`, img);
            });
            formData.append("isActive", data.isActive);

            const response = await axiosInstance.post(`content/createContent`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/content");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("position", data.position);
            formData.append("title", data.title);
            formData.append("description", data.description);
            data.desktopImg.forEach((img) => {
                formData.append(`desktopImg`, img);
            });
            formData.append("isActive", data.isActive);
            const response = await axiosInstance.put(`content/updateContent/${editData?._id}`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/content");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mx-4 mt-5">
                    <h3 className="page-title">Add Content </h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <form ref={formRef} className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label htmlFor="position" className="col-sm-3 col-form-label">Position</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="position"
                                                name="position"
                                                placeholder="Enter position"
                                                value={data.position}
                                                onChange={handleChange}
                                            />
                                            {errors.position && <p className="text-danger">{errors.position}</p>}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label htmlFor="title" className="col-sm-3 col-form-label">Title</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="title"
                                                name="title"
                                                placeholder="Enter title"
                                                value={data.title}
                                                onChange={handleChange}
                                            />
                                            {errors.title && <p className="text-danger">{errors.title}</p>}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label htmlFor="description" className="col-sm-3 col-form-label">Description</label>
                                        <div className="col-sm-9">
                                            <CommonEditor
                                                value={data.description}
                                                placeholder="Enter content ..."
                                                onChange={(value) => handleChange({ target: { name: 'description', value } })}
                                            />
                                            {errors.description && !data?.description?.trim() && (
                                                <div className="text-danger">Description is required</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label htmlFor="desktopImg" className="col-sm-3 col-form-label">Desktop Img</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                name="desktopImg"
                                                className="form-control form-control-sm"
                                                id="desktopImg"
                                                placeholder="Enter desktop img"
                                                multiple
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label htmlFor="isActiveSwitch" className="col-sm-3">Is Active</label>
                                        <div className="col-sm-9">
                                            <div className="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    name="isActive"
                                                    id="isActiveSwitch"
                                                    checked={data.isActive}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                                <label className="custom-control-label" htmlFor="isActiveSwitch">
                                                    {data.isActive ? "Active" : "Deactive"}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <Link to="/content"><button type="button" className="btn btn-secondary mr-2">Back</button></Link>
                                        <button type="submit" className="btn btn-success">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {data.desktopImg.length > 0 &&
                        <div className="col-md-4 stretch-card">
                            <div className="card">
                                <div className="w-100 h-80 text-center mb-4">
                                    <p className="mt-3">Desktop Preview</p>
                                    <br />
                                    {data.desktopImg.map((img, index) => (
                                        <img
                                            key={index}
                                            src={img instanceof File ? URL.createObjectURL(img) : ImageLink(img)}
                                            alt={`desktop_img_preview_${index}`}
                                            className="w-50 preview-img mb-2"
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default AddContent;















// import React, { useState } from 'react'
// import { Link, useLocation, useNavigate } from 'react-router-dom'
// import axiosInstance from '../axiosInterceptor'
// import { toast } from 'react-toastify'
// import { ImageLink } from '../constants'
// import ReactQuill from 'react-quill'

// const AddContent = () => {
//     const navigator = useNavigate();
//     const location = useLocation();
//     const editData = location.state

//     const modules = {
//         toolbar: [
//             [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
//             ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//             [{ 'list': 'ordered' }, { 'list': 'bullet' },
//             { 'indent': '-1' }, { 'indent': '+1' }],
//             ['link', 'image'], // Include the image option in the toolbar
//             ['clean']
//         ],
//     };

//     const formats = [
//         'header', 'font', 'size',
//         'bold', 'italic', 'underline', 'strike', 'blockquote',
//         'list', 'bullet', 'indent',
//         'link', 'image' // Ensure 'image' is included in the formats
//     ];
//     const [data, setData] = useState({
//         position: editData?.position || '',
//         title: editData?.title || '',
//         description: editData?.description || '',
//         desktopImg: editData?.desktopImg || '',
//         // mobileImg: editData?.mobileImg || '',
//         isActive: editData?.isActive || false,
//         // showInHome: editData?.showInHome || false,
//     });
//     const [errors, setErrors] = useState({
//         position: '',
//         title: '',
//     });

//     const handleChange = (e) => {
//         const { name, files, checked, value } = e.target;
//         if (name === 'desktopImg') {
//             setData({ ...data, [name]: files.length > 0 ? files[0] : null });
//         } else if (name === "isActive" || name === "showInHome") {
//             setData({ ...data, [name]: checked });
//         } else {
//             setData({ ...data, [name]: value });
//         }
//         setErrors({ ...errors, [name]: '' });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         let hasErrors = false;

//         if (!data.position.trim()) {
//             setErrors((prevErrors) => ({
//                 ...prevErrors,
//                 position: 'Position is required'
//             }));
//             hasErrors = true;
//         }

//         if (!data.title) {
//             setErrors((prevErrors) => ({
//                 ...prevErrors,
//                 title: 'Title img is required'
//             }));
//             hasErrors = true;
//         }


//         // If there are errors, stop further processing
//         if (hasErrors) {
//             return;
//         }

//         try {
//             const formData = new FormData();
//             formData.append("position", data.position);
//             formData.append("title", data.title);
//             formData.append("description", data.description);
//             if (data.desktopImg instanceof File) {
//                 formData.append("desktopImg", data.desktopImg);
//             }
//             // if (data.mobileImg instanceof File) {
//             //     formData.append("mobileImg", data.mobileImg);
//             // }
//             // formData.append("showInHome", data.showInHome);
//             formData.append("isActive", data.isActive);

//             const response = await axiosInstance.post(`content/createContent`, formData);
//             if (response.status === 200) {
//                 toast.success(response.data.message);
//                 navigator("/content");
//             } else {
//                 toast.error(response.data.message);
//             }
//         } catch (error) {
//             if (error.response) {
//                 toast.error(error.response.data.message);
//             } else {
//                 toast.error('Something went wrong. Please try again!!');
//             }
//         }
//     };
//     const handleUpdate = async (e) => {
//         e.preventDefault();
//         try {
//             const formData = new FormData();
//             formData.append("position", data.position);
//             formData.append("title", data.title);
//             formData.append("description", data.description);
//             if (data.desktopImg instanceof File) {
//                 formData.append("desktopImg", data.desktopImg);
//             }
//             // if (data.mobileImg instanceof File) {
//             //     formData.append("mobileImg", data.mobileImg);
//             // }
//             // formData.append("showInHome", data.showInHome);
//             formData.append("isActive", data.isActive);
//             const response = await axiosInstance.put(`content/updateContent/${editData?._id}`, formData);
//             if (response.status === 200) {
//                 toast.success(response.data.message);
//                 navigator("/content");
//             } else {
//                 toast.error(response.data.message);
//             }
//         } catch (error) {
//             if (error.response) {
//                 toast.error(error.response.data.message);
//             } else {
//                 toast.error('Something went wrong. Please try again!!');
//             }
//         }
//     };

//     return (
//         <>
//             <div className="content-wrapper">
//                 <div className="page-header mx-4 mt-5">
//                     <h3 className="page-title">Add Content </h3>
//                 </div>
//                 <div className="col-md-12 grid-margin stretch-card">
//                     <div className="col-md-8  ">
//                         <div className="card">
//                             <div className="card-body">
//                                 <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
//                                     <div className="form-group row">
//                                         <label
//                                             htmlFor="exampleInputUsername2"
//                                             className="col-sm-3 col-form-label"
//                                         >
//                                             Position
//                                         </label>
//                                         <div className="col-sm-9">
//                                             <input
//                                                 type="number"
//                                                 className="form-control form-control-sm"
//                                                 id="position"
//                                                 name="position"
//                                                 placeholder="Enter position"
//                                                 value={data.position}
//                                                 onChange={handleChange}
//                                             />
//                                             {errors.position && <p className="text-danger">{errors.position}</p>}
//                                         </div>
//                                     </div>

//                                     <div className="form-group row">
//                                         <label
//                                             htmlFor="exampleInputUsername2"
//                                             className="col-sm-3 col-form-label"
//                                         >
//                                             Title
//                                         </label>
//                                         <div className="col-sm-9">
//                                             <input
//                                                 type="text"
//                                                 className="form-control form-control-sm"
//                                                 id="title"
//                                                 name="title"
//                                                 placeholder="Enter title"
//                                                 value={data.title}
//                                                 onChange={handleChange}
//                                             />
//                                             {errors.title && <p className="text-danger">{errors.title}</p>}
//                                         </div>
//                                     </div>

//                                     <div className="form-group row">
//                                         <label
//                                             htmlFor="exampleInputUsername2"
//                                             className="col-sm-3 col-form-label"
//                                         >
//                                             Description
//                                         </label>
//                                         <div className="col-sm-9">
//                                             <ReactQuill
//                                                 theme="snow"
//                                                 value={data.description}
//                                                 modules={modules}
//                                                 formats={formats}
//                                                 placeholder='Enter content ...'
//                                                 onChange={(value) => handleChange({ target: { name: 'description', value } })}
//                                             />
//                                             {errors.content && !data?.content?.trim() && (
//                                                 <div className="text-danger">Content is required</div>
//                                             )}
//                                         </div>
//                                     </div>

//                                     <div className="form-group row">
//                                         <label
//                                             htmlFor="exampleInputUsername2"
//                                             className="col-sm-3 col-form-label"
//                                         >
//                                             Desktop Img
//                                         </label>
//                                         <div className="col-sm-9">
//                                             <input
//                                                 type="file"
//                                                 className="form-control form-control-sm"
//                                                 id="desktopImg"
//                                                 name="desktopImg"
//                                                 placeholder="Enter desktop img"
//                                                 onChange={handleChange}
//                                             />
//                                         </div>
//                                     </div>

//                                     {/* <div className="form-group row">
//                                         <label
//                                             htmlFor="exampleInputUsername2"
//                                             className="col-sm-3 col-form-label"
//                                         >
//                                             Mobile Img
//                                         </label>
//                                         <div className="col-sm-9">
//                                             <input
//                                                 type="file"
//                                                 className="form-control form-control-sm"
//                                                 id="mobileImg"
//                                                 name="mobileImg"
//                                                 placeholder="Enter mobile img"
//                                                 onChange={handleChange}
//                                             />
//                                         </div>
//                                     </div> */}

//                                     {/* <div className="form-group row">
//                                         <label
//                                             htmlFor="showInHome"
//                                             className="col-sm-3 "
//                                         > Show In Home
//                                         </label>
//                                         <div className="col-sm-9">
//                                             <div className="custom-control custom-switch">
//                                                 <input
//                                                     type="checkbox" className="custom-control-input"
//                                                     name='showInHome'
//                                                     id="showInHome"
//                                                     checked={data.showInHome}
//                                                     onChange={(e) => handleChange(e)} />
//                                                 <label className="custom-control-label " for="showInHome">{data.showInHome === true ? "Active" : "Deactive"}</label>
//                                             </div>
//                                         </div>
//                                     </div> */}

//                                     <div className="form-group row">
//                                         <label
//                                             htmlFor="exampleInputUsername2"
//                                             className="col-sm-3 "
//                                         >Is Active
//                                         </label>
//                                         <div className="col-sm-9">
//                                             <div className="custom-control custom-switch">
//                                                 <input
//                                                     type="checkbox" className="custom-control-input"
//                                                     name='isActive'
//                                                     id="isActiveSwitch"
//                                                     checked={data.isActive}
//                                                     onChange={(e) => handleChange(e)} />
//                                                 <label className="custom-control-label " for="isActiveSwitch">{data.isActive === true ? "Active" : "Deactive"}</label>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className='text-center'>
//                                         <Link to="/content"><button className="btn btn-secondary mr-2">
//                                             Back </button></Link>
//                                         <button type="submit" className="btn btn-success">
//                                             Submit
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                     {data.desktopImg &&
//                         <div className="col-md-4 stretch-card">
//                             {/* <div className="card">
//                             <div className="w-100 h-80 text-center mb-4">
//                                 {data.desktopImg instanceof File ? (
//                                     <img src={URL.createObjectURL(data.desktopImg)} alt="desktop_preview" className="w-50 preview-img" />
//                                 ) : (
//                                     ''
//                                 )}
//                                 <div className="card">
//                                     {(
//                                         <div className="border w-100 h-75 text-cente">
//                                             <p className="mt-3">Desktop  Preview</p>
//                                             <br />
//                                             {data.desktopImg instanceof File ? (
//                                                 <img src={URL.createObjectURL(data.desktopImg)} alt="desktop_img_preview" className="w-50 preview-img" />
//                                             ) : (
//                                                 <img src={ImageLink(data.desktopImg)} alt="desktop_img_preview" className="w-50 preview-img" />
//                                             )}
//                                         </div>
//                                     )}



//                                     Video Previews
//                                     {data.desktopImg && typeof data.desktopImg === 'string' && data.desktopImg.match(/\.(mp4|mov|avi)$/) && (
//                                         <div className="w-100 h-80 text-center mb-4">
//                                             <h6 className="mt-3">Desktop Video Preview</h6>
//                                             {data.desktopImg instanceof File ? (
//                                                 <video className="w-50 mb-3" width="320" height="240" controls>
//                                                     <source src={URL.createObjectURL(data.desktopImg)} type="video/mp4" />
//                                                 </video>
//                                             ) : (
//                                                 <video controls className="w-50 mb-3" width="320" height="240">
//                                                     <source src={ImageLink(data.desktopImg)} type="video/mp4" />
//                                                 </video>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div> */}
//                             <div className="card">
//                                 {(
//                                     <div className="w-100 h-80 text-center mb-4">
//                                         <p className="mt-3">Desktop  Preview</p>
//                                         <br />
//                                         {data.desktopImg instanceof File ? (
//                                             <img src={URL.createObjectURL(data.desktopImg)} alt="desktop_img_preview" className="w-50 preview-img" />
//                                         ) : (
//                                             <img src={ImageLink(data.desktopImg)} alt="desktop_img_preview" className="w-50 preview-img" />
//                                         )}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     }
//                 </div>
//             </div>
//         </>
//     )
// }

// export default AddContent;